import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'
import {MeasurementSystemType} from 'types/Localization'

import {Grid} from '@daedalus/atlas/helpers/Grid'
import {SkeletonLoader} from '@daedalus/atlas/SkeletonLoader'
import {ImageProvider} from '@daedalus/core/src/staticContent/types/ImageProvider'

import {HotelImage, IMAGE_HEIGHT, IMAGE_WIDTH} from './HotelImage'
import {PropertySummary, PropertySummarySkeleton} from './PropertySummary'

interface HotelInfoProps {
  hotelName?: string
  starRating?: number
  address?: string
  distanceFromTarget?: number
  hotelImages?: string[]
  cityName?: string
  distanceUnit: MeasurementSystemType
  imageProvider: ImageProvider
}

const HotelInfoWrapper = styled(Grid)(
  ({theme}) => css`
    flex-basis: ${IMAGE_HEIGHT}px;
    background-color: ${theme.colors.background.neutral.c000};
  `
)

const PropertySummaryWrapper = styled.div(
  ({theme}) =>
    css`
      padding: ${theme.layout.spacing.s400}px;
    `
)

export const HotelInfoSkeleton = () => (
  <HotelInfoWrapper container spacing="s000" direction="row" wrap="nowrap">
    <SkeletonLoader width={IMAGE_WIDTH} height={IMAGE_HEIGHT} />
    <PropertySummarySkeleton />
  </HotelInfoWrapper>
)

export const HotelInfo = ({
  hotelName,
  starRating,
  distanceFromTarget,
  address,
  hotelImages,
  imageProvider,
  cityName,
  distanceUnit
}: HotelInfoProps) => {
  // This will be replaced by the actual fetching of the hotel info
  if (!hotelName || !hotelImages || !address || !starRating)
    return <HotelInfoSkeleton />
  return (
    <HotelInfoWrapper container spacing="s000" direction="row" wrap="nowrap">
      <HotelImage imageUrl={hotelImages[0]} imageProvider={imageProvider} />
      <PropertySummaryWrapper>
        <PropertySummary
          distanceFromTarget={distanceFromTarget}
          hotelName={hotelName}
          address={address}
          starRating={starRating}
          cityName={cityName}
          distanceUnit={distanceUnit}
        />
      </PropertySummaryWrapper>
    </HotelInfoWrapper>
  )
}
